import { Goal, ID, Task } from '@griply/types';

export type LinkedItemGoal = Pick<Goal, 'id' | 'parentIds' | 'lifeAreaId'>;

const collectGoalChain = (
  goalId: ID | null,
  goalsById: Map<ID, LinkedItemGoal>,
  linkedItemIds: Set<ID>,
  visited: Set<ID>,
): void => {
  if (!goalId || visited.has(goalId)) {
    return;
  }
  visited.add(goalId);

  const goal = goalsById.get(goalId);
  if (!goal) {
    return;
  }

  linkedItemIds.add(goal.id);
  if (goal.lifeAreaId) {
    linkedItemIds.add(goal.lifeAreaId);
  }

  const parentId = goal.parentIds?.[goal.parentIds.length - 1] ?? null;
  collectGoalChain(parentId, goalsById, linkedItemIds, visited);
};

export const getTaskLinkedItemIds = (
  task: Pick<Task, 'goalId' | 'lifeAreaId'>,
  goalsById: Map<ID, LinkedItemGoal>,
): Set<ID> => {
  const linkedItemIds = new Set<ID>();

  if (task.lifeAreaId) {
    linkedItemIds.add(task.lifeAreaId);
  }

  collectGoalChain(task.goalId, goalsById, linkedItemIds, new Set());

  return linkedItemIds;
};
